import axios from "axios";

const controller = process.env.VUE_APP_API_HAZRAT_MASOOMEH + "ziarat/public";

export default {
  ziaratRegister: (payload) =>
    axios.post(`${controller}`, payload, { headers: { authorization: payload?.token } }),

  ziaratInquiry: (params) =>
    axios.get(`${controller}/inquiry`, {
      params
    }),
};
